import React from 'react';
import { GlobalSettings } from '../../../../../../shared/components/global-settings-wrapper';

type CallOutcomeHeaderProps = {
  headerName: string;
};

const CallOutcomeHeader: React.FC<CallOutcomeHeaderProps> = ({
  headerName,
}) => (
  <GlobalSettings.Header>
    <GlobalSettings.HeaderLeft>
      <GlobalSettings.HeaderTitle title={headerName} />
    </GlobalSettings.HeaderLeft>
  </GlobalSettings.Header>
);

export default CallOutcomeHeader;
